import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './common/components/ProtectedRoute'
import MisSolicitudes from './pages/mis-solicitudes/MisSolicitudes'
import Footer from './common/components/footer/Footer'
import NotFound from "./pages/not-found/Index.jsx";
import PaginaEjemplo from "./pages/pagina-ejemplo/Index.jsx";
import Rendiciones from "@/pages/mis-solicitudes/rendiciones/Rendiciones.jsx";
import Autorizaciones from "./pages/autorizaciones/Autorizaciones.jsx";
import NuevaSolicitud from "./pages/nueva-solicitud/NuevaSolicitud.jsx";
import { Header, useAuth } from '@artprov/design-system'
import SubMenuPrincipal from "./common/components/header/SubMenuPrincipal.jsx"
import Autorizacion from './pages/autorizaciones/components/autorizacion/Autorizacion.jsx'

export default function AppRouter() {
    const { keycloak } = useAuth();

    const opcionesDelMenu = [
        { icon: 'person', opcion: 'Mi información' },
        { icon: 'settings', opcion: 'Configuración' },
        {
            icon: "power_settings_new",
            opcion: "Cerrar sesión",
            onClick: () => keycloak.logout(),
        },
    ];

    return (
        <>
            <Header
                className="justify-center"
                classNameContainerOpciones={"min-w-60"}
                opcionesDelMenu={opcionesDelMenu}
            />
            <SubMenuPrincipal />
            <Routes>
                <Route element={<ProtectedRoute rolPermitido="AUTORIZANTE" />}>
                    <Route path="/autorizaciones" element={<Autorizaciones />} />
                    <Route path="/autorizaciones/detalle-de-solicitud/:id" element={<Autorizacion />} />
                </Route>

                <Route element={<ProtectedRoute />}>
                    <Route path="/" element={<MisSolicitudes />} />
                    <Route path="/:id" element={<MisSolicitudes />} />
                    <Route path="/:id/detalle-de-solicitud" element={<Rendiciones />} />
                    <Route path="/nueva-solicitud/:opcion" element={<NuevaSolicitud />} />
                    <Route path="/ejemplo" element={<PaginaEjemplo />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
            <Footer />
        </>
    )
}
